/**
 * 判断多边形凹凸性
 * @returns 1 凸多边形，-1 凹多边形，0 不符合要求
 */
export function convex(points: any, count: any) {
  let j, k, cross;
  let flag = 0;
  if (count < 3) {
    return 0;
  }
  for (let i = 0; i < count; i++) {
    j = (i + 1) % count;
    k = (i + 2) % count;
    cross = (points[j][0] - points[i][0]) * (points[k][1] - points[j][1]);
    cross -= (points[j][1] - points[i][1]) * (points[k][0] - points[j][0]);
    if (cross < 0) {
      flag |= 1;
    } else if (cross > 0) {
      flag |= 2;
    }
    if (flag === 3) {
      return -1; //CONCAVE
    }
  }
  if (flag !== 0) {
    return 1; //CONVEX
  } else {
    return 0;
  }
}
